export interface SidebarSection {
    id: string
    title: string
    routePatterns: string[]
    position: 'top' | 'middle' | 'bottom'
}

export const DEFAULT_SIDEBAR_SECTIONS: SidebarSection[] = [
    {
        id: 'home',
        title: 'Home',
        routePatterns: ['/', '/home', '/dashboard'],
        position: 'top'
    },
    {
        id: 'applications',
        title: 'Applications',
        routePatterns: ['/cohort', '/insights', '/delivery', '/ingest', '/settings', '/documentation', '/backoffice', '/platform-settings'],
        position: 'middle'
    },
    {
        id: 'resources',
        title: 'Resources',
        routePatterns: ['/help'],
        position: 'bottom'
    }
]

// Platform-specific configuration
export const PLATFORM_SIDEBAR_SECTIONS: SidebarSection[] = [
    {
        id: 'home',
        title: 'Home',
        routePatterns: ['home'],
        position: 'top'
    },
    {
        id: 'applications',
        title: 'Applications',
        routePatterns: ['cohort-builder', 'insights-library', 'back-office', 'platform-settings', 'ingest', 'documentation', 'settings'],
        position: 'middle'
    },
    {
        id: 'resources',
        title: 'Resources',
        routePatterns: [],
        position: 'bottom'
    }
]

// Aspen-specific configuration
export const ASPEN_SIDEBAR_SECTIONS: SidebarSection[] = [
    {
        id: 'home',
        title: 'Home',
        routePatterns: ['/', '/home', '/dashboard'],
        position: 'top'
    },
    {
        id: 'applications',
        title: 'Applications',
        routePatterns: ['/candidates', '/patients', '/studies', '/reports'],
        position: 'middle'
    },
    {
        id: 'resources',
        title: 'Resources',
        routePatterns: ['/help', '/settings'],
        position: 'bottom'
    }
]

export const categorizeSidebarItems = (items: any[], sections: SidebarSection[] = DEFAULT_SIDEBAR_SECTIONS) => {
    const categorized: { [key: string]: any[] } = {}

    sections.forEach((section) => {
        categorized[section.id] = []
    })

    items.forEach((item) => {
        let itemCategorized = false
        for (const section of sections) {
            if (section.routePatterns.some((pattern) => item.route.includes(pattern.replace('/', '')) || item.route === pattern)) {
                categorized[section.id].push(item)
                itemCategorized = true
                break
            }
        }

        // If not categorized, put in applications by default
        if (!itemCategorized) {
            categorized['applications'].push(item)
        }
    })

    return categorized
}
